
const configuredBaseUrl = "#{FowwiiApiBaseUrl}#";
const resolvedBaseUrl = configuredBaseUrl.includes("#{")
  ? "https://localhost:7038/api/"
  : configuredBaseUrl;
export const baseUrl = resolvedBaseUrl.endsWith("/")
  ? resolvedBaseUrl
  : `${resolvedBaseUrl}/`;


//Captcha key

//Test environment reCaptcha keys
//  export const sitekey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
//  export const secretkey = "6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe";

// // Sandbox reCaptcha keys: ******stage*****
// export const sitekey = "6LdViboaAAAAAJ1YVDmbwB7v2Hay2YEWvnfM9IqI";
// export const secretkey = "6LdViboaAAAAAH6KIpMmBn_2foZNVyp42MkCaA5z";

// Production solutionssimplified reCaptcha keys: *****production*******
export const sitekey = "6LdccPIaAAAAAFgM9u3TE3a-Or_AUoJJAQlWYP33";
export const secretkey = "6LdccPIaAAAAAFZtSUQsJ9xt7hlAuVBTlAk4dANV";
